
import React from "react";
import "./Contact.css";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { Helmet } from "react-helmet-async";

const Contact = () => {
    return (
        <>

         <Helmet>
                <title>Contact PRT Academy Hyderabad | IT Training Institute</title>

                <meta
                    name="description"
                    content="Contact PRT Academy in Hyderabad for IT training courses, internships, placement assistance, course details, admissions, career guidance, and expert support."
                />

                <meta
                    name="keywords"
                    content="Contact PRT Academy Hyderabad,PRT Academy Hyderabad Contact,
PRT Academy KPHB,
IT Training Institute in KPHB,
IT Training Institute in Hyderabad,
PRT Academy Address Hyderabad"
                />
            </Helmet>

            <section className="contact-page">

                <div className="page-badge">
                    Contact PRT Academy
                </div>

                <h1>
                    Let's <span>Connect</span>
                </h1>

                <p className="page-intro">
                    Have a question about our courses, internships or
                    placement programs? Get in touch with us.
                </p>

                <div className="contact-grid">

                
<div className="contact-card">
    <h2>Phone</h2>

    <p>
        <FaPhoneAlt className="contact-icon" />

        <a href="tel:+916302005435">
            +91 6302005435
        </a>
    </p>

    <p>
        <FaPhoneAlt className="contact-icon" />

        <a href="tel:+919398219604">
            +91 9398219604
        </a>
    </p>
</div>

<div className="contact-card">
    <h2>Email</h2>

    <p>
        <FaEnvelope className="contact-icon" />

        <a href="mailto:support@prtacademy.com">
            support@prtacademy.com
        </a>
    </p>
</div>



                    <div className="contact-card">
                        <h2>Location</h2>

                        <p>
                            Plot No.142, Third Floor,<br />
                            Balaji Commercial Complex,<br />
                            Bhagyanagar Colony,<br />
                            KPHB, Hyderabad - 500072
                        </p>
                    </div>

                </div>

            </section>
        </>
    );
};

export default Contact;
